import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { isUrgentOnlyFilterAtom } from '../atoms';

/**
 * Drives the single "Urgent" filter — a boolean over the session's
 * `is_urgent` flag.
 */
export const useUrgencyFilter = () => {
  const [isUrgentOnly, setIsUrgentOnly] = useAtom(isUrgentOnlyFilterAtom);

  const toggleUrgentOnly = useCallback(() => {
    setIsUrgentOnly((prev) => !prev);
  }, [setIsUrgentOnly]);

  return {
    isUrgentOnly,
    toggleUrgentOnly,
  };
};
